import { render, staticRenderFns } from "./Novidades.vue?vue&type=template&id=c6bceb1e&scoped=true&"
import script from "./Novidades.vue?vue&type=script&lang=js&"
export * from "./Novidades.vue?vue&type=script&lang=js&"
import style0 from "./novidades-portal.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./novidades-detail.scss?vue&type=style&index=1&lang=scss&"
import style2 from "./Novidades.vue?vue&type=style&index=2&id=c6bceb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bceb1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
